import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service, onGetQuote }) => {
  return (
    <div className="bg-card rounded-lg border border-border hover:border-primary/20 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 ease-out group h-full flex flex-col">
      {/* Card Header */}
      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-start space-x-3 mb-4">
          <div className="relative">
            <div className="w-14 h-14 rounded-lg overflow-hidden ring-1 ring-border group-hover:ring-primary/20 transition-all duration-200">
              <Image
                src={service.image || service.avatar || '/assets/images/no_image.png'}
                alt={service.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
              />
            </div>
            {service.isVerified && (
              <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-accent rounded-full flex items-center justify-center shadow-sm">
                <Icon name="Check" size={10} className="text-white" />
              </div>
            )}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center space-x-2 mb-1">
              <h3 className="font-headline font-semibold text-lg text-foreground group-hover:text-primary transition-colors duration-200 truncate">
                {service.name}
              </h3>
              {service.isVerified && (
                <Icon name="Shield" size={14} className="text-accent flex-shrink-0" />
              )}
            </div>
            {service.specialization && (
              <div className="mb-2">
                <span className="inline-block px-2 py-1 bg-primary/10 text-primary text-xs rounded-full border border-primary/20 font-medium">
                  {service.specialization}
                </span>
              </div>
            )}
            {service.location && (
              <div className="flex items-center space-x-1 text-xs text-muted-foreground">
                <Icon name="MapPin" size={12} />
                <span>{service.location}</span>
              </div>
            )}
          </div>
        </div>

        {/* Service Description */}
        <p className="text-sm text-muted-foreground mb-4 line-clamp-3 flex-1">
          {service.description}
        </p>

        {/* Tags */}
        {service.tags && service.tags.length > 0 ? (
          <div className="flex flex-wrap gap-1 mb-4">
            {service.tags.slice(0, 3).map((tag, index) => (
              <span
                key={index}
                className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full border border-blue-200 font-medium"
              >
                {tag}
              </span>
            ))}
            {service.tags.length > 3 && (
              <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
                +{service.tags.length - 3} more
              </span>
            )}
          </div>
        ) : (
          <div className="mb-4">
            <span className="text-xs text-gray-400 italic">No tags available</span>
          </div>
        )}

        {/* Get Quote Button */}
        <div className="mt-auto">
          <Button
            variant="default"
            size="sm"
            fullWidth
            iconName="MessageSquare"
            iconPosition="left"
            onClick={() => onGetQuote(service)}
          >
            Get Quote
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard; 